module.exports = __webpack_public_path__ + "static/media/quegudan2.5e480062.png";